import { useApi, useToast, useWorkspace } from '~/contexts';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { PageLoader } from '~/routes/public/pages';

export default function XeroRedirect() {
  const api = useApi();
  const location = useLocation();
  const { navigateWorkspace } = useWorkspace();
  const toast = useToast();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      const params = new URLSearchParams(location.search);
      const { workspaceId } = JSON.parse(params.get('state'));
      const { data: workspace } = await api.www.workspaces(workspaceId).get();

      try {
        const { data } = await api.xero.postRedirectUri({ uri: window.location.href });
        toast.success('Successfully connected with Xero');
        await navigateWorkspace(workspace.key, `/settings/integrations/xero/${data.connectionId}?action=setup`);
      } catch (error) {
        toast.error(error.message);
        await navigateWorkspace(workspace.key, '/settings/integrations');
      }
    })();
  }, [location.search, api, navigateWorkspace, toast, history]);

  return <PageLoader />;
}
